/**
 * Title-only hero of the Metal Resources landing pages (`../MetalResourcesLandingRyerson.tsx`,
 * `../MetalResourcesLandingSTS.tsx`): the page's `h1` on a tertiary band, larger from `lg` up.
 */
import React from "react";
import { ContentSection } from "@ryerson/frontend.layout";
import { Typography } from "@ryerson/frontend.typography";
import { Media } from "@ryerson/frontend.next";

/** One language's hero copy. */
export type MetalResourcesHeroProps = {
	title: string;
};

/** Renders the landing page's `h1`. */
const MetalResourcesHero: React.FC<MetalResourcesHeroProps> = ({ title }) => {
	return (
		<ContentSection type="tertiary">
			<Media greaterThanOrEqual="lg">
				<Typography
					variant="h1"
					type="tertiary"
					css={{ fontSize: "75px", marginTop: "68px", marginBottom: "59px" }}
				>
					{title}
				</Typography>
			</Media>
			<Media lessThan="lg">
				<Typography
					variant="h1"
					type="tertiary"
					css={{ marginTop: "30px", marginBottom: "41px" }}
				>
					{title}
				</Typography>
			</Media>
		</ContentSection>
	);
};

export default MetalResourcesHero;
